import reduce from 'lodash/reduce';

export const breakpoints = {
	0: 'small',
	576: 'medium',
	767: 'large',
	992: 'spMedium',
	1023: 'xlarge',
	1200: 'xxlarge',
};

export const breakpointsByName = {
	...reduce(
		breakpoints,
		(result, value, key) => ({ ...result, [value]: Number.parseInt(key) }),
		{},
	),
	// One-off page/component breakpoints that aren't part of the `breakpoints`
	// tier ladder above (so they don't affect useViewportWidth's bucketing),
	// but are duplicated as raw pixel literals across JS and SCSS - kept here
	// as the single source of truth for both sides.
	header: 900, // $sp-headerbp in Header.scss / Menu.js
	facilitySidebar: 841, // raw 841px breakpoint in FacilityUnitListV2.scss
};
